import React, { useEffect, useState } from "react";
import { useChannelStateContext } from "stream-chat-react";
import { db } from "../FirebaseConfig";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import { Card, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import formatPrice from "../lib/formatPrice";

const ProductsInChat = () => {
  const { channel } = useChannelStateContext();
  const [products, setProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const handleClose = () => setIsModalOpen(false);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (!channel || channel.type !== "team") {
      setLoading(false);
      return;
    }

    async function fetchProductIds() {
      try {
        const creatorId =
          channel.created_by || (channel.data && channel.data.created_by.id);
        console.log("creatorId", creatorId);

        if (!creatorId) {
          console.error("Channel creator ID not found.");
          setLoading(false);
          return;
        }

        const shoppingListRef = collection(
          db,
          "users",
          creatorId,
          "shoppingList"
        );
        const shoppingListQuery = query(
          shoppingListRef,
          where("listId", "==", channel.id)
        );
        const shoppingListSnapshot = await getDocs(shoppingListQuery);

        if (!shoppingListSnapshot.empty) {
          // Assuming there is only one matching document.
          const shoppingListDoc = shoppingListSnapshot.docs[0];
          const productsRef = collection(
            db,
            "users",
            creatorId,
            "shoppingList",
            shoppingListDoc.id,
            "products"
          );
          const productsSnapshot = await getDocs(productsRef);
          const ids = productsSnapshot.docs.map((doc) => doc.id);

          // Fetch product details for each product ID
          const productDetails = await Promise.all(
            ids.map(async (id) => {
              const productRef = doc(db, "products", id);
              const productSnapshot = await getDoc(productRef);
              if (productSnapshot.exists()) {
                const productData = { id, ...productSnapshot.data() };
                return productData;
              }
              return null;
            })
          );

          // Filter out null values and set the products state
          setProducts(productDetails.filter((product) => product !== null));
        } else {
          console.log("No shopping list found with listId:", channel.id);
          setProducts([]);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchProductIds();
  }, [channel]);

  // Only render if the channel exists and is a team channel.
  if (!channel || channel.type !== "team") return null;

  return (
    <>
      {products.length > 0 && (
        <div
          className={`m-0 d-flex flex-row gap-2 w-100 ${
            isSmallScreen ? "position-relative vw-100" : ""
          } px-2 px-lg-3 py-2 border-bottom hiddenScrollbar`}
          style={{
            overflow: "auto hidden",
            whiteSpace: "nowrap",
            height: "400px",
          }}
          onClick={() => setIsModalOpen(true)}
        >
          {loading ? (
            <LoadingSpinner height="20vh" />
          ) : (
            <>
              {products.map((product) => (
                <div key={product.id} id={product.id}>
                  {product.imageUrl && (
                    <div style={{ width: "140px" }}>
                      <img
                        src={product.imageUrl}
                        alt={product.name}
                        width={"140px"}
                        style={{
                          // position: "relative",
                          objectFit: "cover",
                          objectPosition: "top",
                          height: "200px",
                          borderRadius: "12px",
                        }}
                        onError={() =>
                          (document.getElementById(product.id).style.display =
                            "none")
                        }
                      />
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      )}
      <style jsx>
        {`
          .productsInChat .modal-dialog {
            // max-width: 58.5rem;
            max-width: 47.5rem;
          }
        `}
      </style>
      <Modal
        className="productsInChat"
        show={isModalOpen}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="modalLabelCreateEvents">
            {channel.data.name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            className="d-flex gap-3"
            style={{ overflow: "auto", maxWidth: "47.5rem" }}
          >
            {products.map((product) => (
              <div className="shadow-sm p-2 rounded-2">
                <div className="d-flex flex-column">
                  <div
                    style={{
                      position: "relative",
                      height: "15rem",
                      width: isSmallScreen ? "9rem" : "13.25rem",
                    }}
                  >
                    <Link to={`/ProductDetails/${product?.id}`}>
                      <Card.Img
                        variant="top"
                        className="rounded-2"
                        src={product?.imageUrl}
                        alt={`Image of the product`}
                        style={{
                          objectFit: "cover",
                          objectPosition: "top",
                          height: "100%",
                        }}
                      />
                    </Link>
                    <div
                      style={{
                        position: "absolute",
                        backgroundColor: "#59A800",
                        color: "white",
                        width: "4rem",
                        fontSize: "10px",
                        alignContent: "center",
                        height: "1.5rem",
                      }}
                      className="rounded-pill text-center top-0 end-0 m-1"
                    >
                      PKR {formatPrice(product?.newPrice)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductsInChat;
